import { render, staticRenderFns } from "./emoji-picker.vue?vue&type=template&id=ca1f642e&scoped=true&"
import script from "./emoji-picker.vue?vue&type=script&lang=js&"
export * from "./emoji-picker.vue?vue&type=script&lang=js&"
import style0 from "./emoji-picker.vue?vue&type=style&index=0&id=ca1f642e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1f642e",
  null
  
)

export default component.exports